<div style="display: flex; align-items: start; gap: 20px">
  <app-filterable-table
    #userTable2
    [title]="'Group: ' + groupName"
    [tableView]="tableView"
    [leftToolbarButtonText]="'BACK'"
    (selectedRecord)="handleUserSelected($event)"
    [options]="tableViewOptions"
    (leftToolbarButtonClick)="btnCancel_click()"
  ></app-filterable-table>

<table class="cpo-selectable-table" style="width:fit-content; margin-top: 76px;">
  <thead>
    <tr class="cpo-selectable-table__header-row">
      <th class="no-sort">Group Users</th>
      <th class="no-sort"></th>
    </tr>
  </thead>
  @for (user of users; track user) {
      <tr
        [ngClass]="{ even: even, odd: odd }"
        class="cpo-selectable-table__row"
      >
        <td>
          {{ user.firstName }} {{ user.lastName }}
        </td>
        <td style="cursor: pointer" [title]="'remove'" (click)="btnRemoveUser_click(user)">
          <app-icon type="MinusRemove" [color]="'var(--archive-red)'"></app-icon>
        </td>
      </tr>
    }
    @if (users.length == 0) {
      <tr>
        <td colspan="2">No users in group</td>
      </tr>
    }
  </table>
  

